/**
 * Fonte ÚNICA de verdade para planos no frontend.
 * Deve refletir EXATAMENTE /app/backend/config.py (PLAN_LIMITS, PLAN_PRICES, WHATSAPP_NUMBER_LIMITS).
 *
 * Sempre que ajustar preços/limites, atualizar aqui E no config.py.
 */

export const PLAN_CATALOG = [
  {
    id: 'free',
    label: 'Free',
    price: 0,
    limit: 10,
    whatsapp: 1,
    limit_text: 'Até 10 avaliações/mês',
    short_desc: 'R$ 0 - 10 avaliações/mes',
  },
  {
    id: 'basico',
    label: 'Básico',
    price: 29.90,
    limit: 15,
    whatsapp: 1,
    limit_text: 'Até 15 avaliações/mês',
    short_desc: 'R$ 29,90 - 15 avaliações/mes',
  },
  {
    id: 'pro',
    label: 'Pro',
    price: 39.90,
    limit: 30,
    whatsapp: 2,
    limit_text: 'Até 30 avaliações/mês',
    short_desc: 'R$ 39,90 - 30 avaliações/mes',
  },
  {
    id: 'enterprise',
    label: 'Empresarial',
    price: 59.90,
    limit: 60,
    whatsapp: 3,
    limit_text: 'Até 60 avaliações/mês',
    short_desc: 'R$ 59,90 - 60 avaliações/mes',
  },
  {
    id: 'elite',
    label: 'Elite',
    price: 99.90,
    limit: 100,
    whatsapp: 4,
    limit_text: 'Até 100 avaliações/mês',
    short_desc: 'R$ 99,90 - 100 avaliações/mes',
  },
  {
    id: 'five_stars',
    label: '5 Estrelas',
    price: 149.90,
    limit: null,
    whatsapp: null,
    limit_text: 'Avaliações ILIMITADAS',
    short_desc: 'R$ 149,90 - Ilimitado',
  },
  {
    id: 'livre',
    label: 'LIVRE',
    price: 0,
    limit: null,
    whatsapp: null,
    limit_text: 'Ilimitado - Todos os recursos',
    short_desc: 'R$ 0 - Ilimitado - Todos os recursos',
  },
];

/** Planos disponíveis para venda (exclui free e livre) */
export const SELLABLE_PLAN_IDS = ['basico', 'pro', 'enterprise', 'elite', 'five_stars'];

/** Planos comissionáveis para implantação por Parceiro/Afiliado */
export const IMPLANT_PLAN_IDS = ['free', 'basico', 'pro', 'enterprise', 'elite', 'five_stars'];

export const PLAN_LABELS = PLAN_CATALOG.reduce((acc, p) => {
  acc[p.id] = p.label;
  return acc;
}, { basic: 'Free' }); // legacy alias

export const PLAN_OPTIONS_ADMIN = PLAN_CATALOG.map((p) => ({
  id: p.id,
  label: p.label,
  desc: p.short_desc,
}));

/** Helpers */
export const getPlan = (id) => PLAN_CATALOG.find((p) => p.id === id);

/** Prateleira: quais planos aparecem na vitrine pública (flag no /master) */
export const fetchShelfIds = async () => {
  try {
    const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/public/plans-shelf`);
    const data = await res.json();
    return Array.isArray(data.visible_ids) && data.visible_ids.length
      ? data.visible_ids
      : ['enterprise', 'elite', 'five_stars'];
  } catch {
    return ['enterprise', 'elite', 'five_stars'];
  }
};
